<template>
  <div>
    <div class="header-card">
      <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="back">
      </div>
      <div class="header-card-text">
        <h3> {{ firstname }} {{ lastname}}</h3>
        <p>Your Profile</p>

      </div>
    </div>
    <div class="content">
      <div class="withdrawal-card">
        <h4 class="fnt-14 cabin-family semi-bold">Withdrawal Bank Details</h4>
        <div class="account-details" v-if="bank">
          <p class="cabin-family secondary bold fnt-16">{{ bank.account_number}}</p>
          <p class="cabin-family secondary bold fnt-16">{{ bank.bank_name}}</p>
          <p class="cabin-family secondary bold fnt-16">{{ bank.account_name}}</p>
        </div>
        <div v-else>
          <p class="cabin-family secondary bold fnt-16">Bank detail not added yet</p>
        </div>
      </div>

      <div class="links-card-section inv" @click="updatePassword()">
        <div class="first-col open-sans bold">
          Change Password
        </div>
        <div class="third-col">
        <img src="@/assets/right-chevron.png"  height="11" width="6" alt="icon">
        </div>
      </div>

      <div class="links-card-section inv logout" @click="logout()">
        <div class="first-col open-sans bold">
          Logout
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron-r.png" height="11" width="6" alt="icon">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logoutActive: false,
      lastname: '',
      firstname: '',
      bank: {},
    };
  },
  mounted() {
    this.getBank();
    const user = JSON.parse(localStorage.getItem('user'));
    this.firstname = user.firstname;
    this.lastname = user.lastname;
  },
  methods: {
    async getBank() {
      const url = `${this.$baseUrl}/user/bank`;
      const res = await this.$http({ url, method: 'GET' });
      this.bank = res.data.bank;
    },
    logout() {
      this.logoutActive = true;
      this.$store.dispatch('logout').then(() => {
        setTimeout(() => {
          this.$router.push('/signin');
        }, 1000);
      });
    },
    updatePassword() {
      this.$router.push('/password/update');
    },
    bankSetting() {
      this.$router.push('/bank/setting');
    },
    back() {
      this.$router.go(-1);
    },
  },

};
</script>

<style lang="scss" scoped>
  .withdrawal-card{
    padding: 1rem 1rem;
    border: 1px solid #FFF;
    background-color: #FFF;
    border-radius: 8px;
    text-align: center;
    margin-bottom: 1rem;
  }
  .account-details{
    margin-top: 1rem;
    p{
      margin-block-end: .25em;
    }
  }
  .active{
    background-color: #EE0E4C;
    color: #FFF;
    font-weight: 600;
  }
  .first-col{
    text-align: left;
    width: 50%;
  }
  .logout{
    background-color: #FFDDE6;
    color: #EE0E4C;
  }
  .copy-text{
    font-size: 12px;
    color: #50A948;
    margin-bottom: 0;
  }
</style>
